import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';
import countries from './countries.json';
// types
import { PredecessorsTypes } from './types';
import { ProjectsSortEnum } from 'redux-store/api/profile-preference';

export const urlRegex = /(https?:\/\/[^\s]+)/g;

export const countriesSelectValues = countries.map(({ name, code, image }) => ({
  label: name,
  value: code,
  icon: image,
}));

export const colors = [
  '#D12D36',
  '#42A9BF',
  '#FF7051',
  '#9648C6',
  '#D3AC1E',
  '#3652C6',
  '#BD30B7',
  '#15682D',
  '#FCA311',
  '#D4A373',
  '#FF006E',
  '#06D6A0',
  '#7678ED',
  '#C9F299',
  '#F3F956',
  '#97FF30',
];

export const colorsOptions = colors.map((color) => ({ label: '', value: color, color: color }));

export const predecessorsTypesOptions = [
  { label: 'Start to start', value: PredecessorsTypes.startToStart },
  { label: 'Start to finish', value: PredecessorsTypes.startToFinish },
  { label: 'Finish to start', value: PredecessorsTypes.finishToStart },
  { label: 'Finish to finish', value: PredecessorsTypes.finishToFinish },
];

export const GanttLinkTypes = {
  0: 'FINISH-TO-START',
  1: 'START-TO-START',
  2: 'FINISH-TO-FINISH',
  3: 'START-TO-FINISH',
};

export const TIME_OPTIONS = [
  { label: '12 AM', value: '0' },
  { label: '01 AM', value: '1' },
  { label: '02 AM', value: '2' },
  { label: '03 AM', value: '3' },
  { label: '04 AM', value: '4' },
  { label: '05 AM', value: '5' },
  { label: '06 AM', value: '6' },
  { label: '07 AM', value: '7' },
  { label: '08 AM', value: '8' },
  { label: '09 AM', value: '9' },
  { label: '10 AM', value: '10' },
  { label: '11 AM', value: '11' },
  { label: '12 PM', value: '12' },
  { label: '01 PM', value: '13' },
  { label: '02 PM', value: '14' },
  { label: '03 PM', value: `15` },
  { label: '04 PM', value: `16` },
  { label: '05 PM', value: `17` },
  { label: '06 PM', value: `18` },
  { label: '07 PM', value: `19` },
  { label: '08 PM', value: `20` },
  { label: '09 PM', value: `21` },
  { label: '10 PM', value: `22` },
  { label: '11 PM', value: `23` },
];

export const WEEKDAY_OPTIONS = [
  { label: 'Sunday', value: '0' },
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
];

export const JOB_TITLES = [
  { label: 'Owner', value: 'Owner' },
  { label: 'Client', value: 'Client' },
  { label: 'Project Manager', value: 'Project Manager' },
  { label: 'Superintendent', value: 'Superintendent' },
  { label: 'Agent', value: 'Agent' },
  { label: 'Designer', value: 'Designer' },
  { label: 'Office Manager', value: 'Office Manager' },
  { label: 'Estimator', value: 'Estimator' },
  { label: 'Warranty Manager', value: 'Warranty Manager' },
  { label: 'Purchasing Manager', value: 'Purchasing Manager' },
  { label: 'Architect', value: 'Architect' },
  { label: 'Engineer', value: 'Engineer' },
  { label: 'Subcontractor', value: 'Subcontractor' },
  { label: '+Add New', value: 'Other', optionColor: '#4D6EF5' },
];

export const TEMP_ITEM_ID_COEFFICIENT = 50;

export const DOCUMENT_FORMATS = [
  '.pdf',
  '.txt',
  '.doc',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.csv',
  '.ppt',
  '.pptx',
  '.key',
];

export const FILTER_OPTIONS = [
  { sort: ProjectsSortEnum.CREATED_AT, order: 'DESC', value: 'Newest' },
  { sort: ProjectsSortEnum.CREATED_AT, order: 'ASC', value: 'Oldest' },
  { sort: ProjectsSortEnum.NAME, order: 'ASC', value: 'A-Z' },
  { sort: ProjectsSortEnum.NAME, order: 'DESC', value: 'Z-A' },
  { sort: ProjectsSortEnum.OVERDUE, order: 'DESC', value: 'Overdue' },
  { sort: ProjectsSortEnum.ACTIVITY_COUNT, order: 'DESC', value: 'Activity' },
  { sort: ProjectsSortEnum.UNREAD_COUNT, order: 'DESC', value: 'Unread' },
];

export const IMAGE_TYPES =
  'image/jpg, image/jpeg, image/png, image/webp, image/tiff, image/avif, image/heic, image/heif';

export const FILE_TYPES =
  'application/pdf, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.apple.keynote';

export const CABINET_FILE_TYPES =
  'image/jpg, image/jpeg, image/png, image/webp, image/gif, image/tiff, image/avif, image/heic, image/heif, application/pdf, text/csv, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.apple.keynote';

export const MAX_FILE_SIZE = 52428800;
export const MAX_FILE_COUNT = 10;

export const OWNER_ROLE_ID = 0;
export const ADMIN_ROLE_ID = 1;

export const SIDE_PANEL_WIDTH = 457;
export const HEADER_HEIGHT = 73;
export const ACTIVITY_FEED_HEADER_HEIGHT = 52;

const commonSvgStyle = 'width:16px;height:14px;';

// Gray colors for hashtags user doesn't have permission to access
export const hashtagGrayColors = {
  color: '#9E9E9E',
  background: '#F5F5F5',
};

export const hashtagColorsMap: Record<
  HashtagMentionTypeEnum,
  { color: string; background: string; iconUrl: string }
> = {
  [HashtagMentionTypeEnum.fileCabinetItem]: {
    color: '#47D06F',
    background: '#CCFFDB',
    iconUrl: `
      <svg style="${commonSvgStyle}" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.33463 1.66671V3.20006C7.33463 3.9468 7.33463 4.32017 7.47996 4.60538C7.60779 4.85626 7.81176 5.06024 8.06265 5.18807C8.34786 5.33339 8.72123 5.33339 9.46797 5.33339H11.0013M11.3346 6.87585V9.33337C11.3346 11.2002 11.3346 12.1336 10.9713 12.8467C10.6517 13.4739 10.1418 13.9838 9.5146 14.3034C8.80156 14.6667 7.86814 14.6667 6.0013 14.6667C4.13446 14.6667 3.20104 14.6667 2.488 14.3034C1.86079 13.9838 1.35086 13.4739 1.03128 12.8467C0.667969 12.1336 0.667969 11.2002 0.667969 9.33337V6.51882C0.667969 4.79135 0.667969 3.92762 0.980364 3.25779C1.31154 2.54769 1.88228 1.97695 2.59239 1.64577C3.26221 1.33337 4.12595 1.33337 5.85342 1.33337C6.60827 1.33337 6.9857 1.33337 7.34216 1.41241C7.72171 1.49657 8.08361 1.64647 8.4115 1.85535C8.71944 2.05151 8.98632 2.31839 9.52008 2.85216L9.77254 3.10461C10.349 3.68112 10.6373 3.96937 10.8434 4.30576C11.0262 4.604 11.1609 4.92915 11.2425 5.26927C11.3346 5.65289 11.3346 6.06054 11.3346 6.87585Z" stroke="#47D06F" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  [HashtagMentionTypeEnum.phaseItem]: {
    color: '#4D6EF5',
    background: '#E0EEFF',
    iconUrl: `
      <svg style="${commonSvgStyle}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66797 0.833496L6.66797 3.3335M13.3346 0.833496V3.3335M14.168 6.66683H5.83464M9.66796 18.3335H10.3346C13.1349 18.3335 14.535 18.3335 15.6046 17.7885C16.5454 17.3092 17.3103 16.5443 17.7897 15.6034C18.3346 14.5339 18.3346 13.1338 18.3346 10.3335V9.66683C18.3346 6.86657 18.3346 5.46644 17.7897 4.39688C17.3103 3.45607 16.5454 2.69116 15.6046 2.2118C14.535 1.66683 13.1349 1.66683 10.3346 1.66683H9.66797C6.86771 1.66683 5.46757 1.66683 4.39802 2.2118C3.45721 2.69116 2.6923 3.45607 2.21294 4.39688C1.66797 5.46644 1.66797 6.86657 1.66797 9.66683V10.3335C1.66797 13.1338 1.66797 14.5339 2.21294 15.6034C2.6923 16.5443 3.45721 17.3092 4.39802 17.7885C5.46757 18.3335 6.8677 18.3335 9.66796 18.3335Z" stroke="#4D6EF5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  [HashtagMentionTypeEnum.selection]: {
    color: '#EDC533',
    background: '#FFF9E5',
    iconUrl: `
      <svg style="${commonSvgStyle}" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.33203 0.666626L5.33203 2.66663M10.6654 0.666626V2.66663M11.332 5.33329H4.66536M7.73203 14.6666H8.26536C10.5056 14.6666 11.6257 14.6666 12.4813 14.2307C13.234 13.8472 13.8459 13.2352 14.2294 12.4826C14.6654 11.6269 14.6654 10.5068 14.6654 8.26663V7.73329C14.6654 5.49308 14.6654 4.37298 14.2294 3.51733C13.8459 2.76468 13.234 2.15276 12.4813 1.76927C11.6257 1.33329 10.5056 1.33329 8.26537 1.33329H7.73203C5.49182 1.33329 4.37172 1.33329 3.51607 1.76927C2.76342 2.15276 2.1515 2.76468 1.76801 3.51733C1.33203 4.37298 1.33203 5.49308 1.33203 7.73329V8.26663C1.33203 10.5068 1.33203 11.6269 1.76801 12.4826C2.1515 13.2352 2.76342 13.8472 3.51607 14.2307C4.37172 14.6666 5.49182 14.6666 7.73203 14.6666Z" stroke="#EDC533" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
  [HashtagMentionTypeEnum.selectionOption]: {
    color: '#FF8368',
    background: '#FFE7E1',
    iconUrl: `
      <svg style="${commonSvgStyle}" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.0013 7.33329H8.0013M4.0013 9.99996H6.66797M8.66785 2.02352C8.66798 2.01568 8.66805 2.00783 8.66805 1.99996C8.66805 1.26358 8.0711 0.666626 7.33472 0.666626H4.66805C3.93167 0.666626 3.33472 1.26358 3.33472 1.99996C3.33472 2.00782 3.33479 2.01567 3.33492 2.0235M8.66785 2.02352C8.65527 2.74903 8.06323 3.33329 7.33472 3.33329H4.66805C3.93954 3.33329 3.34748 2.74902 3.33492 2.0235M8.66785 2.02352C10.1713 2.21093 11.3346 3.4934 11.3346 5.04758V9.33329C11.3346 11.2001 11.3346 12.1336 10.9713 12.8466C10.6517 13.4738 10.1418 13.9837 9.5146 14.3033C8.80156 14.6666 7.86814 14.6666 6.0013 14.6666C4.13446 14.6666 3.20104 14.6666 2.488 14.3033C1.86079 13.9837 1.35086 13.4738 1.03128 12.8466C0.667969 12.1336 0.667969 11.2001 0.667969 9.33329V5.04758C0.667969 3.49334 1.83143 2.21084 3.33492 2.0235" stroke="#FF8368" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  },
};
